import { roomListAtom } from 'config/store'
import { useAtom } from 'jotai'
import React, { useState, useContext, useEffect } from 'react'
import { Container, Row, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useMediaQuery, mediaQueryPoint } from 'utils/hooks'
import RoomSearchAndCreate from './components/RoomSearchAndCreate'
import RoomTable from './components/RoomTable'
import RoomTableMobile from './components/RoomTableMobile'
import { useLocation } from 'react-router-dom'
import { SocketContext } from 'utils/socket'
import { useQuery } from 'react-query'
import { getListRoomOfGameQuery, getLevelRoomOfGameQuery } from 'dataLayer/game'
import { useParams } from 'react-router-dom'
import { getLanguage } from 'utils/localStorage'

function RoomPage() {
	let location = useLocation()
	const { pathname } = useLocation()
	const language = getLanguage()
	const { socket, setSocketRoomId } = useContext(SocketContext)
	React.useEffect(() => {
		setSocketRoomId(0)
	}, [location])
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		})
	}, [pathname])
	const { roomId } = useParams()
	const { t } = useTranslation()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const [level, setLevel] = useState('1')

	// const [key, setKey] = useState(t('room.tab.bronze'))
	// const [roomList] = useAtom(roomListAtom)
	const { data, isLoading } = useQuery(
		getListRoomOfGameQuery(roomId, null, null, '', level),
	)
	let roomList = data?.rooms || []
	const dataLevel = useQuery(getLevelRoomOfGameQuery(roomId))
	let dataRoomLevel = dataLevel?.data?.roomLevels || []
	const roomListAvailable = roomList
		?.filter(item => item.status === 0)
		?.map(item => item.id)
	const randomRoom =
		roomListAvailable[Math.floor(Math.random() * roomListAvailable.length)]
	return (
		<>
			<Container className="roompage-container" fluid>
				<Row className={`${isMobileMD ? 'roompage-row-mobile' : ''}`}>
					<RoomSearchAndCreate
						dataList={roomList}
						randomRoom={randomRoom}
						level={level}
					/>
					<Tabs
						id="controlled-tab-example"
						activeKey={level}
						onSelect={k => setLevel(k)}
						className={`mt-3 mb-md-0 justify-content-center justify-content-md-end roompage-tab ${isMobileMD ? 'mobile-style-room' : ''
							} `}
					>
						{Array.isArray(dataRoomLevel) &&
							dataRoomLevel.map(it => {
								return (
									<Tab
										key={it.id}
										eventKey={it.id}
										title={t(`room.tab.${it.name}`)}
									>
										{isMobileMD ? (
											<RoomTableMobile level={level} />
										) : (
											<RoomTable level={level} randomRoom={randomRoom} />
										)}
									</Tab>
								)
							})}

						{/* <Tab eventKey={t('room.tab.bronze')} title={t('room.tab.bronze')}>
							{isMobileMD ? (
								<RoomTableMobile />
							) : (
								<RoomTable randomRoom={randomRoom} />
							)}
						</Tab>
						<Tab eventKey={t('room.tab.silver')} title={t('room.tab.silver')}>
							{isMobileMD ? (
								<RoomTableMobile />
							) : (
								<RoomTable randomRoom={randomRoom} />
							)}
						</Tab>
						<Tab eventKey={t('room.tab.gold')} title={t('room.tab.gold')}>
							{isMobileMD ? (
								<RoomTableMobile />
							) : (
								<RoomTable randomRoom={randomRoom} />
							)}
						</Tab>
						<Tab eventKey={t('room.tab.diamond')} title={t('room.tab.diamond')}>
							{isMobileMD ? (
								<RoomTableMobile />
							) : (
								<RoomTable randomRoom={randomRoom} />
							)}
						</Tab> */}
					</Tabs>
				</Row>
			</Container>
		</>
	)
}

export default RoomPage
